import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LsKeys } from 'enums';
import { createArticle, getArticles } from 'state/thunks/articleThunk/articleThunk';
import {
  getCommissions,
  updateCommissions,
} from 'state/thunks/commissionThunk/commissionThunk';

const initialState = {
  doctors: null,
  doctor: null,
  count: null,
  lastPage: null,
  page: null,
  user: null,
  isLoading: false,
  visits: [],
  commissions: [],
};

const slice = createSlice({
  name: 'commission',
  initialState,
  reducers: {
    setLogOut: () => initialState,
  },
  extraReducers: (builder: ActionReducerMapBuilder<any>) => {
    builder
      .addCase(getCommissions.fulfilled, (state, action: PayloadAction<any>) => {
        state.commissions = action.payload;
      })
      .addCase(updateCommissions.fulfilled, (state, action: PayloadAction<any>) => {
        state.commissions = action.payload;
      });
  },
});

export const commissionActions = slice.actions;

export const commissionReducer = slice.reducer;
